const clearPressedState = (target) => {
  target.style.transform = target.dataset.pressResetTransform || "";
  target.style.boxShadow = target.dataset.pressResetBoxShadow || "";
};

const setPressedState = (target) => {
  target.style.transform = target.dataset.pressTransform || "translateY(3px)";
  target.style.boxShadow = "none";
};

export const pressable3dHandlers = {
  onMouseDown: (event) => {
    setPressedState(event.currentTarget);
  },
  onMouseUp: (event) => {
    clearPressedState(event.currentTarget);
  },
  onMouseLeave: (event) => {
    clearPressedState(event.currentTarget);
  },
  onTouchStart: (event) => {
    setPressedState(event.currentTarget);
  },
  onTouchEnd: (event) => {
    clearPressedState(event.currentTarget);
  },
  onTouchCancel: (event) => {
    clearPressedState(event.currentTarget);
  },
  onBlur: (event) => {
    clearPressedState(event.currentTarget);
  },
};
